import React from "react";

/**
 * Invisible button wrapper so avatar / name open the player modal without
 * changing inner component styles.
 */
export function PlayerPickTrigger({ children, ariaLabel, onOpen }) {
    return (
        <button
            type="button"
            className="m-0 inline-flex cursor-pointer border-0 bg-transparent p-0 text-left font-inherit text-inherit"
            aria-label={ariaLabel}
            onClick={(e) => {
                e.stopPropagation();
                onOpen();
            }}
        >
            {children}
        </button>
    );
}
